module.exports = __webpack_public_path__ + "static/img/040.be01ecf5.png";